// Module
var code = "<mx-text-box label=\"{{::vm.i18n.value}}\" ng-model=\"vm.condition.value\" ng-required=\"true\" flex>\r\n</mx-text-box>\r\n<br>";
// Exports
export default code;